"use client";

import { cn } from "@/lib/utils";

const variants = {
  header: {
    tag: "h1",
    desktop: {
      fontWeight: 400,
      fontSize: "48px",
      lineHeight: "56px",
      letterSpacing: "-0.03em",
    },
    mobile: {
      fontWeight: 400,
      fontSize: "32px",
      lineHeight: "40px",
      letterSpacing: "-0.03em",
    },
    color: "#F8F7F4",
  },
  subheader: {
    tag: "h2",
    desktop: {
      fontWeight: 500,
      fontSize: "48px",
      lineHeight: "56px",
      letterSpacing: "-0.03em",
    },
    mobile: {
      fontWeight: 500,
      fontSize: "32px",
      lineHeight: "40px",
      letterSpacing: "-0.03em",
    },
    color: "#F8F7F4",
  },
  title: {
    tag: "h2",
    desktop: {
      fontWeight: 400,
      fontSize: "48px",
      lineHeight: "56px",
      letterSpacing: "-0.02em",
    },
    mobile: {
      fontWeight: 400,
      fontSize: "32px",
      lineHeight: "40px",
      letterSpacing: "-0.02em",
    },
    color: "#F8F7F4",
  },
  text: {
    tag: "p",
    desktop: {
      fontWeight: 400,
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "-0.002em",
    },
    mobile: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "-0.002em",
    },
    color: "#A4A4A4",
  },
  subtext: {
    tag: "p",
    desktop: {
      fontWeight: 300,
      fontSize: "18px",
      lineHeight: "28px",
      letterSpacing: "-0.002em",
    },
    mobile: {
      fontWeight: 300,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "-0.002em",
    },
    color: "#A4A4A4",
  },
  caption: {
    tag: "p",
    desktop: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "-0.002em",
    },
    mobile: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "-0.002em",
    },
    color: "#F8F7F4",
  },
};

export const Text = ({ variant = "text", as, className, children, center = false, ...props }) => {
  const config = variants[variant];
  const Tag = as || config.tag;

  return (
    <>
      {/* Desktop */}
      <Tag
        className={cn("hidden md:block", center && "text-center", className)}
        style={{ ...config.desktop, color: config.color }}
        {...props}
      >
        {children}
      </Tag>
      {/* Mobile */}
      <Tag
        className={cn("block md:hidden", center && "text-center", className)}
        style={{ ...config.mobile, color: config.color }}
        {...props}
      >
        {children}
      </Tag>
    </>
  );
};
